import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { persistor, store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { ApolloProvider } from "@apollo/client";
import client from "./apollo/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createWeb3Modal } from "@web3modal/wagmi/react";
import { Buffer } from "buffer";
import { Loader } from "@googlemaps/js-api-loader";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { queryClient, wagmiConfig } from "./wagmi/client";
import { WagmiProvider } from "wagmi";
import { QueryClientProvider } from "@tanstack/react-query";
import { OrokiiPayWidgetLoader } from "./components";
import { H } from "highlight.run";
import { ErrorBoundary as HightlightErrorBoundary } from "@highlight-run/react";

const projectId = process.env.REACT_APP_WAGMI_PROJECT_ID;

createWeb3Modal({
  wagmiConfig,
  projectId: projectId ?? "",
  themeMode: "dark",
  themeVariables: {
    "--w3m-font-family": "Poppins, sans-serif",
    "--w3m-accent": "#215759",
  },
});

// createWeb3Modal({ wagmiConfig, projectId: projectId ?? "", chains });

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

(window as any).Buffer = Buffer;

export const loader = new Loader({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string,
  version: "weekly",
  libraries: ["places"],
});

function MyFallbackComponent({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

H.init(process.env.REACT_APP_HIGHLIGHT_KEY, {
  serviceName: "frontend-app",
  tracingOrigins: true,
  networkRecording: {
    enabled: true,
    recordHeadersAndBody: true,
    urlBlocklist: [
      // insert full or partial urls that you don't want to record here
      // Out of the box, Highlight will not record these URLs (they can be safely removed):
      "https://www.googleapis.com/identitytoolkit",
      "https://securetoken.googleapis.com",
    ],
  },
});

root.render(
  // <React.StrictMode>
  <HightlightErrorBoundary>
    <ErrorBoundary FallbackComponent={MyFallbackComponent}>
      <ApolloProvider client={client}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <WagmiProvider config={wagmiConfig}>
              <QueryClientProvider client={queryClient}>
                <App />
                <OrokiiPayWidgetLoader />
              </QueryClientProvider>
            </WagmiProvider>
          </PersistGate>
        </Provider>
      </ApolloProvider>
      <ToastContainer />
    </ErrorBoundary>
  </HightlightErrorBoundary>

  // </React.StrictMode>
);

reportWebVitals();
